import { getCerebroHeaders } from 'api/Cerebro/headers'
import { orgScopedApiClient } from 'api/orgScopedClient'
import { AsyncUpdate, SovKeyword, UpdatePayload, Report } from 'types'

import {
    CerebroApiOptionsHeaders,
    CerebroBulkUpdateResponse,
    CerebroPaginatedResponse,
    CerebroResourceResponse,
} from '../types'

export const getSovKeyword = (
    keywordId: string,
    params: Record<string, unknown> = {}
): Promise<CerebroResourceResponse<SovKeyword>> =>
    orgScopedApiClient.get(`/api/sov/keyword/${keywordId}/`, {
        params,
    })

export const createSovKeyword = (
    data: Partial<SovKeyword>
): Promise<CerebroResourceResponse<SovKeyword>> =>
    orgScopedApiClient.post(`/api/sov/keywords/`, data)

export const createSovKeywords = (data: {
    items: Partial<SovKeyword>[]
}): Promise<CerebroBulkUpdateResponse<SovKeyword>> =>
    orgScopedApiClient.post(`/api/sov/keywords/`, data)

export const updateSovKeyword = (
    keywordId: string,
    data: Record<string, unknown>
): Promise<CerebroResourceResponse<SovKeyword>> =>
    orgScopedApiClient.patch(`/api/sov/keyword/${keywordId}/`, data)

export const updateSovKeywords = (
    data: UpdatePayload,
    params: Record<string, unknown> = {}
): Promise<CerebroBulkUpdateResponse<SovKeyword>> =>
    orgScopedApiClient.patch(`/api/sov/keywords/`, data, { params })

export const asyncUpdateSovKeywords = (
    data: Record<string, unknown>,
    params: Record<string, unknown>
): Promise<CerebroResourceResponse<AsyncUpdate>> =>
    orgScopedApiClient.patch(`/api/sov/keywords/mutate/`, data, {
        params,
    })

export const deleteSovKeyword = (
    keywordId: string
): Promise<CerebroResourceResponse<void>> =>
    orgScopedApiClient.delete(`/api/sov/keyword/${keywordId}/`)

export const getSovKeywords = (
    params: Record<string, unknown> = {},
    options: { headers?: CerebroApiOptionsHeaders } = {
        headers: {},
    }
): Promise<CerebroPaginatedResponse<SovKeyword>> =>
    orgScopedApiClient.get(`/api/sov/keywords/`, {
        params,
        headers: getCerebroHeaders(options.headers),
    })

export const getSovKeywordsAsyncExport = (
    params: Record<string, unknown>
): Promise<CerebroResourceResponse<Report>> =>
    orgScopedApiClient.get(`/api/sov/keywords/export/async/`, {
        params,
    })
